import React from 'react'
import { Content, MainContainer } from '../HomepageStarterEmail/styled'
import { useMenu } from '../../../hooks/useHelpMenu'
import { Loading } from '../../shared/Loading'
import { useTheme, useMediaQuery } from '@mui/material'
import { Avatar } from '../Avatar'
import styled from 'styled-components'
import { useHomepage } from '../../../hooks/useUser'
import { useTranslation } from 'react-i18next'
import { speedTier } from '../../../constants/form'
import { useExistantProducts } from '../../../hooks/useUser'
import { Alert } from 'react-bootstrap'
import { OptionsMenu, OptionsMenuDrawer, DrawerContent} from './OptionsMenu'
import { 
	Header, Body, CtaCard, 
	CtaIcon, CtaSubtitle, CtaTitle, 
	EstimateRow, Logout, NavPill, 
	NavRow, StartButton, TimeIcon,
} from './styled'
import { H1, H4, UserName, Greeting, CustomAlertHeading, StyledLink } from '../styled'
import { Drawer } from '@mui/material'
import { Button } from '../../shared/simple/Button'
import { theme } from '../../../theme/theme'
import { useEmailUser } from '../../../hooks/useUser'
import { useStartRequestGuide } from '../../../hooks/useTourGuides'
import { Tooltip } from '@mui/material'
import { statusRequest } from '../../../constants/base'
import { isUndefinedNull, notUndefinedNull } from '../../../helpers/shared'
import { useNewProductRequestMutation } from '../../../redux/services/services'
import { useDispatch, useSelector } from 'react-redux'
import { getProductRequest } from '../../../redux/actions/user'
import { USER_SET_IS_EXPECTING_NEW_DATA_PRODUCT_REQUEST } from '../../../redux/types/user'
import { ThreeCircles } from 'react-loader-spinner'

const { seventh } = theme

const AltHomepage = () => {
	const {
		isMenuOpen,
		onClick,
		tiers,
		loading,
		heightTier,
		desktop,
		setIsMenuOpen
	} = useMenu();
	const {
		code,
		expiredFiles,
		level,
		onLogout,
		rejectedFiles,
		routeExpired,
		username,
		routeRequests,
		routeCreatedProducts,
		isProcessingDocuments,
		routeRejected,
		options,
		dataProduct, 
		personData
	} = useHomepage();
	const [tier, setTier] = React.useState()
	const { clientProducts } = useExistantProducts();
	const [open, setOpen] = React.useState(false);
	const [isButtonLoading, setIsButtonLoading] = React.useState(false)
	const { email } = useEmailUser() 

	const toggleDrawer = (newOpen) => {
		setOpen(newOpen);
	};

	React.useEffect(() => {
		if (tiers?.length) { 
			setTier(tiers.filter(tier => tier?.unique_name === speedTier)[0])
		}
	}, [tiers])

	const responsiveTheme = useTheme();
	const isMobile = useMediaQuery(responsiveTheme.breakpoints.down('sm'));
	const { t } = useTranslation()

	const capitalize = (str) => {
		if (!str) return '';
		return str.charAt(0).toUpperCase() + str.slice(1);
	};

	const { Tour, isTourDismissed } = useStartRequestGuide(username)

	const { isExpectingNewDataProductRequest, selectedProduct } = useSelector(state => state.user)
	const { id: userId } = useSelector(state => state.personData.data)
	const [newProductRequest] = useNewProductRequestMutation()
	const dispatch = useDispatch()
	const onApplicationClick = async () => {
		setIsButtonLoading(true)
		try {
			if (isExpectingNewDataProductRequest){
				await newProductRequest({ user_id: userId, application: selectedProduct?.application?.unique_name })
				dispatch({
					type: USER_SET_IS_EXPECTING_NEW_DATA_PRODUCT_REQUEST,
					payload: null
				})
				// ? Will probably need to apply some kind of trick in here
				await dispatch(getProductRequest(userId))
				onClick(tier)
			} else {
				onClick(tier)
			}
		} catch (error) {
			console.error(error)
		} finally {
			setIsButtonLoading(false)
		}

	}
	

  return (
		<>
			{ (dataProduct?.status?.unique_description === statusRequest.processing) && 
				(isUndefinedNull(isTourDismissed) || (notUndefinedNull(isTourDismissed) && isTourDismissed === 'false')) &&
				Tour }
			{
				(loading) ? (
					<Loading></Loading>
				) : (
					<MainContainer
						customFlexDirection='column'
						isMobile={isMobile}
					>
						<Content
							isMobile={isMobile}
							customWidth={'700px'}
						>
							<Header>
								<Logout
									onClick={onLogout}
								>
									{t('homepage.logout')}
								</Logout>
								<OptionsMenuDrawer
									handleClick={() => toggleDrawer(true)}
								/>
								<Avatar 
									margin='60px'
									customMarginTopXs='40px'
									customImgWidth='120px'
									customJustifyContentXs='center'
								/>
							</Header>
							<Body>
								<Greeting>
									<H1 className="mb-2">
										{ t("homepage.greeting") }
									</H1>
									&nbsp;
									<UserName title={capitalize(username || email[0]?.text) }>
										{ capitalize(username || email[0]?.text) }
									</UserName>
								</Greeting>
								<H4 className="mb-2" id='wisenrollCode'>
									<Tooltip
										describeChild
										title={t('homepage.codeTooltip')}
									>
										<>
											{ t("homepage.code") }&nbsp;<strong>{ code }</strong>
										</>
									</Tooltip>
								</H4>

								{/* // ! Flaggables */}
								{
									/* // * Beneficieries and Co-owners Section. */
									(clientProducts?.length > 0) && (
										<H4 className="mb-1">
											<StyledLink
												className="p-0"
												onClick={ routeCreatedProducts }
												color="first"
												xs={12}
												name=""
											>
												{ t("block.edition") }
											</StyledLink>
										</H4>)
									}
									{/*// * Rejected Files alert. */}
									{(rejectedFiles && !isProcessingDocuments) && (
										<Alert
											variant='danger'
										>
											<CustomAlertHeading>
												{ t("common.rejectedFilesTitle") }
											</CustomAlertHeading>
											<StyledLink
												className="p-0"
												onClick={ routeRejected }
												color="seventh"
												xs={12}
												name="link_rejected_files"
											>
												<p className="p-0 m-0">
													{ t("common.rejectedFiles") }
												</p>
											</StyledLink>
										</Alert>
									)}
									{/* // * Expired Files Alert */}
									{expiredFiles && (
										<StyledLink
											className="p-0"
											onClick={ routeExpired }
											color="third"
											xs={12}
											name="link_expired_files"
										>
											<p className="p-0 m-0" style={{ color: seventh }}>
												{ t("common.expiredFiles") }
											</p>
										</StyledLink>
									)}

							</Body>
							<CtaCard>
								<CtaTitle>
									{ t('homepage.getStarted') }
								</CtaTitle>
								<CtaSubtitle>
									{ t('homepage.startQuickly') }
								</CtaSubtitle>
								<StartButton>
									<Button
									disabled={ loading || isButtonLoading }
									onClick={() => onApplicationClick()}
									color='first'
									padding='8'
									id='startButton'
									style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
								>
									{isButtonLoading ? (
										<ThreeCircles height='20' width='20' color='white' ariaLabel='three-circles-loading' />
									) : (
										<span>
											{ notUndefinedNull(personData?.first_name) && dataProduct?.status?.unique_description !== statusRequest.success ? t('homepage.continue') : t('homepage.start') }
										</span>
									)}
									</Button>
								</StartButton>
								<EstimateRow>
									<TimeIcon>⏱</TimeIcon>
									{ t('homepage.estimatedTime') }
								</EstimateRow>
							</CtaCard>
						</Content>
      					<Drawer open={open} onClose={() => toggleDrawer(false)}>
							<DrawerContent 
								toggleDrawer={setOpen}
								options={options}
							/>
						</Drawer>
					</MainContainer>
				)
			}
		</>
  )
}

export default AltHomepage